<template>
    <div class="layout-erro-container">
        <div class="logo-area">
            <img :src="logo" alt="Process to use" />
        </div>

        <div class="page-content">
            <router-view />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'LayoutErro',
    setup() {
        const logo = new URL('@/assets/images/logo.png', import.meta.url).href
        return { logo }
    }
})
</script>

<style lang="scss" scoped>
.layout-erro-container {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-color: #EFEFEF;
    background-image: url('@/assets/images/fundo_p2u.svg');
    background-repeat: no-repeat;
    background-position: right;
    background-size: cover;
    overflow: hidden; 
    font-family: 'Arial', sans-serif;
}

.logo-area {
    position: absolute;
    top: 40px;
    left: 60px;
    z-index: 20;

    img {
        width: 180px;
        height: auto;
    }
}

.page-content {
    width: 100%;
    height: 100%;
    position: relative;
}

/* --- MOBILE --- */
@media (max-width: 950px) {
    .layout-erro-container {
        height: auto;
        min-height: 100vh;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        padding: 2rem;
        box-sizing: border-box;
        background-position: center; 
    }

    .logo-area {
        position: static;
        margin-bottom: 2rem;
        display: flex;
        justify-content: flex-start;
        width: 100%;

        img {
            width: 140px;
        }
    }

    .page-content {
        height: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
}
</style>